import Basepath from '@/constants/downloadable-file-basepath'

export default {
    methods: {
        downloadUrl(filename) {
            return `${Basepath.PATH}/${filename}`
        },
    },
}
